import classNames from "classnames/bind";
import Button from "common/blocks/Button";
import React, { useCallback, useEffect, useRef, useState } from "react";
import clearCache from "services/content-manager/clear-cache/clear-cache";
import styles from "./ClearCache.module.scss";

const cx = classNames.bind(styles);

type ClearCacheProps = object;

const ClearCache: React.FC<ClearCacheProps> = () => {
    const hasRanRef = useRef(false);
    const [clearing, setClearing] = useState(false);
    const [clearedSuccess, setClearedSuccess] = useState(false);
    const [clearedFailed, setClearedFailed] = useState(false);
    const clearCacheCooldownMs = 5000;

    const handleClearCache = useCallback(async () => {
        setClearing(true);

        clearCache((cleared) => {
            hasRanRef.current = true;
            setClearing(false);
            if (cleared) {
                setClearedSuccess(true);
            } else {
                setClearedFailed(true);
            }
        });
    }, []);

    useEffect(() => {
        if (!hasRanRef.current) return;
        let timeout: NodeJS.Timeout;

        timeout = setTimeout(() => {
            hasRanRef.current = false;
            setClearedSuccess(false);
            setClearedFailed(false);
        }, clearCacheCooldownMs);

        return () => {
            clearTimeout(timeout);
        };
    }, [clearedSuccess]);

    return process.env.NODE_ENV === "development" ? (
        <Button
            isDisabled={clearing || clearedSuccess || clearedFailed}
            onClick={handleClearCache}
            size="slim"
            className={cx("clearCache", { failed: clearedFailed, success: clearedSuccess })}
        >
            {clearing && !clearedFailed && !clearedSuccess && "Clearing..."}
            {!clearing && !clearedFailed && !clearedSuccess && "Clear Cache"}
            {!clearing && clearedFailed && !clearedSuccess && "Clear Cache Failed"}
            {!clearing && !clearedFailed && clearedSuccess && "Cache Cleared!"}
        </Button>
    ) : null;
};

export default ClearCache;
